import styled from 'styled-components'
import { colors } from '@monorepo/theme'

export const Overlay = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  /* Above the decorative microsites arrow (100000) and the cart dialog
     (1302): the dealer must not be able to reach past this. */
  z-index: 100001;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background: rgba(11, 44, 77, 0.55);
`

export const Panel = styled.div`
  width: 100%;
  max-width: 560px;
  max-height: 100%;
  overflow-y: auto;
  background: #ffffff;
  border-radius: 6px;
  padding: 28px;
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.25);
`

export const Title = styled.h1`
  font-family: PFDINText;
  font-size: 22px;
  font-weight: 700;
  color: #0b2c4d;
  margin-bottom: 6px;
`

export const Subtitle = styled.p`
  font-family: PFDINText;
  font-size: 13.5px;
  line-height: 1.45;
  color: ${colors.mediumGrey};
  margin-bottom: 20px;
`

export const List = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`

export const Option = styled.button<{ selected?: boolean }>`
  width: 100%;
  text-align: left;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  gap: 3px;
  padding: 14px 16px;
  border-radius: 5px;
  background: ${({ selected }) => (selected ? '#eaf1fb' : '#ffffff')};
  border: 1px solid ${({ selected }) => (selected ? '#337ace' : '#d8dde3')};

  &:hover {
    border-color: #337ace;
  }
`

export const OptionName = styled.span`
  font-family: PFDINText;
  font-size: 15px;
  font-weight: 700;
  color: #222222;
`

export const OptionMeta = styled.span`
  font-family: PFDINText;
  font-size: 12.5px;
  color: ${colors.mediumGrey};
`

/* Marks the accounts where the dealer is a principal, since that is what
   changes whether they can see and spend Co-Op. */
export const PrincipalTag = styled.span`
  align-self: flex-start;
  margin-top: 4px;
  font-family: PFDINText;
  font-size: 10.5px;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #1e7e46;
  background: #e9f6ef;
  border-radius: 3px;
  padding: 2px 7px;
`

export const Actions = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 22px;
`

export const Continue = styled.button<{ disabled?: boolean }>`
  font-family: PFDINText;
  font-size: 15px;
  text-transform: uppercase;
  padding: 13px 30px;
  border-radius: 4px;
  color: #ffffff;
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  background-color: ${({ disabled }) => (disabled ? '#a9c7ec' : '#337ace')};
  border: 1px solid ${({ disabled }) => (disabled ? '#a9c7ec' : '#337ace')};
`
